module.exports = __webpack_public_path__ + "img/password_checked.12e91a58.svg";